import React from 'react';

const Social = () => {
  return (
    <ul className="list-inline list-social">
      <li className="list-inline-item">
        <a href="#" target="_blank" rel="noreferrer noopener">
          <i className={`fab fa-github`}></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a href="#" target="_blank" rel="noreferrer noopener">
          <i className={`fab fa-linkedin-in`}></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a href="#" target="_blank" rel="noreferrer noopener">
          <i className={`fab fa-twitter`}></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a href="#" target="_blank" rel="noreferrer noopener">
          <i className={`fab fa-facebook-f`}></i>
        </a>
      </li>
    </ul>
  );
}

export default Social;